import { Injectable } from '@angular/core';
import { 
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot 
} from "@angular/router";
import { OrmService } from './orm.service';

@Injectable()
export class GuardianService implements CanActivate {

  constructor(
    private router: Router,
    private ORM: OrmService
  ) {}

  IsLogin: any;

  canActivate(route: ActivatedRouteSnapshot, status: RouterStateSnapshot) {
    if (this.ORM.isAuthenticated()) {
      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page
    this.router.navigate(['/login']);
    return false;
  }
}